module.exports = __webpack_public_path__ + "img/head4.eeb88075.png";